export class Filter {
	public savedFilterId: string;
	public caseId: string;
	public createdById: string;
	public title: string;
	public dateTimeCreated: Date;
	public isPinned: boolean;
	public isShared: boolean;
	public lifeCycle: number;
	public filterXml?: any;
	public filterJson: string;
	public filterJsonOld?: any;
	public filterText: string;
	public error: boolean;
}
